var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t(_vm.$route.meta.title),"items":_vm.breadcrumb}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t(_vm.$route.meta.description))+" ")]),_c('settlement-catalog-table',{attrs:{"paginate":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }